// extracted by mini-css-extract-plugin
var _1 = "Text__Text___eOXUK";
var _2 = "Text__error___IKuIU";
var _3 = "Text__icon___G3Mcf";
var _4 = "Text__placeholder___NC93C";
var _5 = "Text__sidebar___po4Sn";
var _6 = "Text__wide___Kwwlw";
var _7 = "Text__wiggle___VYYYD";
export { _1 as "Text", _2 as "error", _3 as "icon", _4 as "placeholder", _5 as "sidebar", _6 as "wide", _7 as "wiggle" }
